"use strict";

import * as THREE from "three";

import Bloom from './Bloom';
import Stem from "./Stem";

class Flower extends THREE.Group {
    stem: Stem;
    bloom: Bloom;

    clock: THREE.Clock = new THREE.Clock();

    constructor(stem, bloom) {
        super();

        stem: Stem;
        bloom: Bloom;

        this.stem = stem;
        this.bloom = bloom;

        this.add(stem);
        this.add(bloom);
    }

    grow(stemDuration, bloomDuration) {
        this.stem.grow(stemDuration, () => {
            this.bloom.grow(bloomDuration, null);
        });
    }

    update(time) {
        this.stem.update(time);
        this.bloom.update(time);
    }

    destroy() {
        this.stem.geometry.dispose();
    }
}

export default Flower;